import React from "react";
import {push} from 'react-router-redux';
import {store} from '../../store/store';
import { connect } from 'react-redux';
import applicationCenterService from '../../services/Employee/application-center-service';

// import DayoffApprovalService from '../../services/Approval/dayoff-approval-service';


import {Button, Card, PullToRefresh, WhiteSpace, Toast} from 'antd-mobile';


import MobileWrapper from '../../layouts/MobileWrapper';





class MobileApplyBreakDownList extends React.Component {


    constructor(props) {
        super(props)

        this.state = {
            dataCount:0,
            data: [],
            pageSize:0,
            cardListRefreshing: false,
            cardListHeight: document.documentElement.clientHeight,
            document_id:[]
        }





    }

    componentWillMount() {
        this.getListData();
    }


    getListData(gets = {page: 1}) {

        applicationCenterService.myBreakDownApply(gets, res => {

            this.setState({dataCount: res.data.Object.Total})
            this.setState({data: this.state.data.concat(res.data.Object.Data)})
            this.setState({pageSize: res.data.Object.PageSize})

            console.log(this.state.data)
            this.setState({refreshing: false});
        }, err => {
        })

    }



    editApply = () => {
        console.log("edit")
    }

    delApply = (approvalTypeStr ,id) =>  {


        Toast.loading('正在撤销...', 99999, () => {});


        let posts = {
            id:id,
            approval_type_str:approvalTypeStr
        };
        applicationCenterService.UndoApproval(posts, res => {
            Toast.hide();


            if (res.data.Success) {
                Toast.success('撤销成功 !!!', 1);
            }else{
                Toast.fail('撤销失败 !!!', 1);
            }


        }, err => {});

    }


    goToDetail = (params) => {
        var path = {
            pathname:'/mobile/mobile-apply-break-down-detail',
            state:params,
        }
        if(this.props.user.currentUser.PermissionDict.mobile_apply_break_down_list.detail_value){
            store.dispatch(push(path))
        }
    }






    render() {
        const self = this;
        const { currentUser } = this.props.user
        var cards = this.state.data.map(function (apply, index) {
            return (
                <div key={index}>
                    <WhiteSpace size="lg"/>
                    <Card full onClick={(e) => self.goToDetail(apply)}>
                        <Card.Header title={apply.relaxation_type_str} extra={<span>{apply.approval_status_str}</span>}/>
                        <Card.Body>
                            <div>开始时间: {apply.start_date_str} {apply.start_time}  </div>
                            <div>结束时间: {apply.end_date_str} {apply.end_time}  </div>
                            <div>调休时长: {apply.relaxation_hours} 小时</div>
                            <div>申请时间: {apply.created_time_str}</div>
                            <div>申请事由: {apply.remark}</div>
                        </Card.Body>

                        {
                            !!(apply.approval_status === 1) &&

                            <Card.Footer content="" extra={<div> 
                                {currentUser.PermissionDict.mobile_apply_break_down_list.revert_value&&
                                <Button style={{width: '140px', float:"right", marginRight: "5px"}} 
                                size="small" type="warning" onClick={(e) => self.delApply(apply.approval_type,apply.id )}>撤销</Button>}
                                </div>}/>
                        }


                    </Card>


                </div>
            );

        });


        return <div>


            <PullToRefresh
                ref = {el => this.ptr = el}
                style = {{
                    height: this.state.cardListHeight,
                    overflow: 'auto',
                }}
                direction = 'up'
                refreshing = {this.state.cardListRefreshing}
                onRefresh = {() => {

                    if(this.state.data.length < this.state.dataCount){
                        this.setState({refreshing: true});
                        this.getListData({page: Math.floor(this.state.data.length/this.state.pageSize) + 1});
                    }
                }}
            >
                {currentUser.PermissionDict.mobile_apply_break_down_list.c_value &&
                <Button type="primary" onClick={_el => store.dispatch(push("/mobile/mobile-apply-break-down-create"))}>申请调休</Button>}

                {currentUser.PermissionDict.mobile_apply_break_down_list.r_value && cards}


            </PullToRefresh>

        </div>


    }
}

// export default MobileWrapper(MobileApplyBreakDownList);
const mapStateToProps = state => {
    return {
        user: state.user
    }
}
const mapDispatchToProps = {
}
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileApplyBreakDownList));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileApplyBreakDownList.js